import { PART_TYPES } from '../faceParts/data/enums'

export const FILL = 'fill'
export const SECONDARYFILL = 'secondaryFill'
export const OUTLINE = 'outline'
export const SECONDARYOUTLINE = 'secondaryOutline'
export const GRADIENT = 'gradient'
export const PUPIL = 'pupil'
export const SKIN_COLOR = 'skinColor'
export const COLOR_KEY = 'colorKey'

export const skinColors = Object.freeze({
  '#EBECEC': {
    [COLOR_KEY]: '#EBECEC',
    [FILL]: '#EBECEC',
    [OUTLINE]: '#545659',
    [GRADIENT]: ['#BBBDBE', '#EBECEC'],
  },
  '#4E2C16': {
    [COLOR_KEY]: '#4E2C16',
    [FILL]: '#4E2C16',
    [OUTLINE]: '#0D0A08',
    [GRADIENT]: ['#27180E', '#4E2C16'],
  },
  '#845534': {
    [COLOR_KEY]: '#845534',
    [FILL]: '#845534',
    [OUTLINE]: '#2A1B13',
    [GRADIENT]: ['#603813', '#845534'],
  },
  '#AF7E58': {
    [COLOR_KEY]: '#AF7E58',
    [FILL]: '#AF7E58',
    [OUTLINE]: '#60371A',
    [GRADIENT]: ['#754C28', '#AF7E58'],
  },
  '#CC7D5A': {
    [COLOR_KEY]: '#CC7D5A',
    [FILL]: '#CC7D5A',
    [OUTLINE]: '#773223',
    [GRADIENT]: ['#A8583B', '#CC7D5A'],
  },
  '#D8A280': {
    [COLOR_KEY]: '#D8A280',
    [FILL]: '#D8A280',
    [OUTLINE]: '#893F2B',
    [GRADIENT]: ['#BC7B55', '#D8A280'],
  },
  '#C4958B': {
    [COLOR_KEY]: '#C4958B',
    [FILL]: '#C4958B',
    [OUTLINE]: '#834B42',
    [GRADIENT]: ['#A56E66', '#C4958B'],
  },
  '#DCB9B6': {
    [COLOR_KEY]: '#DCB9B6',
    [FILL]: '#DCB9B6',
    [OUTLINE]: '#B27976',
    [GRADIENT]: ['#BC8884', '#DCB9B6'],
  },
  '#F39882': {
    [COLOR_KEY]: '#F39882',
    [FILL]: '#F39882',
    [OUTLINE]: '#8C3E25',
    [GRADIENT]: ['#C9735C', '#F39882'],
  },
  '#F8B0A2': {
    [COLOR_KEY]: '#F8B0A2',
    [FILL]: '#F8B0A2',
    [OUTLINE]: '#B05A43',
    [GRADIENT]: ['#DD8476', '#F8B0A2'],
  },
  '#FBC7AA': {
    [COLOR_KEY]: '#FBC7AA',
    [FILL]: '#FBC7AA',
    [OUTLINE]: '#D66F40',
    [GRADIENT]: ['#F59478', '#FBC7AA'],
  },
  '#FBD4AB': {
    [COLOR_KEY]: '#FBD4AB',
    [FILL]: '#FBD4AB',
    [OUTLINE]: '#B96F29',
    [GRADIENT]: ['#E9AB71', '#FBD4AB'],
  },
  '#FDE5DA': {
    [COLOR_KEY]: '#FDE5DA',
    [FILL]: '#FDE5DA',
    [OUTLINE]: '#F8A98D',
    [GRADIENT]: ['#F9C7B4', '#FDE5DA'],
  },
})

export const eyeColors = Object.freeze({
  '#99A092': {
    [COLOR_KEY]: '#99A092',
    [PUPIL]: '#4A5242',
    [GRADIENT]: ['#4A5242', '#99A092'],
  },
  '#57C5D3': {
    [COLOR_KEY]: '#57C5D3',
    [PUPIL]: '#0F4B59',
    [GRADIENT]: ['#0F4B59', '#57C5D3'],
  },
  '#80BE62': {
    [COLOR_KEY]: '#80BE62',
    [PUPIL]: '#1A341E',
    [GRADIENT]: ['#1E5B2D', '#80BE62'],
  },
  '#9B6932': {
    [COLOR_KEY]: '#9B6932',
    [PUPIL]: '#010101',
    [GRADIENT]: ['#3B2314', '#9B6932'],
  },
  '#754C28': {
    [COLOR_KEY]: '#754C28',
    [PUPIL]: '#2A1B13',
    [GRADIENT]: ['#3B2314', '#754C28'],
  },
  '#833A2E': {
    [COLOR_KEY]: '#833A2E',
    [PUPIL]: '#200F0B',
    [GRADIENT]: ['#4A1E1A', '#833A2E'],
  },
  '#353535': {
    [COLOR_KEY]: '#353535',
    [PUPIL]: '#000000',
    [GRADIENT]: ['#141414', '#353535'],
  },
})

export const hairColors = Object.freeze({
  '#000000': {
    [COLOR_KEY]: '#000000',
    [FILL]: '#000000',
    [OUTLINE]: '#70717D',
  },
  '#010101': {
    [COLOR_KEY]: '#010101',
    [FILL]: '#010101',
    [OUTLINE]: '#7772A5',
  },
  '#705A52': {
    [COLOR_KEY]: '#705A52',
    [FILL]: '#705A52',
    [OUTLINE]: '#2C201C',
  },
  '#713126': {
    [COLOR_KEY]: '#713126',
    [FILL]: '#713126',
    [OUTLINE]: '#2C130F',
  },
  '#704636': {
    [COLOR_KEY]: '#704636',
    [FILL]: '#704636',
    [OUTLINE]: '#2C1812',
  },
  '#9E5844': {
    [COLOR_KEY]: '#9E5844',
    [FILL]: '#9E5844',
    [OUTLINE]: '#662D20',
  },
  '#845534': {
    [COLOR_KEY]: '#845534',
    [FILL]: '#845534',
    [OUTLINE]: '#2A1B13',
  },
  '#9D725B': {
    [COLOR_KEY]: '#9D725B',
    [FILL]: '#9D725B',
    [OUTLINE]: '#663F2F',
  },
  '#9E6C39': {
    [COLOR_KEY]: '#9E6C39',
    [FILL]: '#9E6C39',
    [OUTLINE]: '#6D421A',
  },
  '#C67A35': {
    [COLOR_KEY]: '#C67A35',
    [FILL]: '#C67A35',
    [OUTLINE]: '#955524',
  },
  '#9D855B': {
    [COLOR_KEY]: '#9D855B',
    [FILL]: '#9D855B',
    [OUTLINE]: '#675130',
  },
  '#DBBF82': {
    [COLOR_KEY]: '#DBBF82',
    [FILL]: '#DBBF82',
    [OUTLINE]: '#B69240',
  },
  '#AE3124': {
    [COLOR_KEY]: '#AE3124',
    [FILL]: '#AE3124',
    [OUTLINE]: '#F49556',
  },
  '#DC714B': {
    [COLOR_KEY]: '#DC714B',
    [FILL]: '#DC714B',
    [OUTLINE]: '#AF3E25',
  },
  '#F79857': {
    [COLOR_KEY]: '#F79857',
    [FILL]: '#F79857',
    [OUTLINE]: '#CD6428',
  },
  '#FFCD7B': {
    [COLOR_KEY]: '#FFCD7B',
    [FILL]: '#FFCD7B',
    [OUTLINE]: '#E29825',
  },
  '#FFEEBC': {
    [COLOR_KEY]: '#FFEEBC',
    [FILL]: '#FFEEBC',
    [OUTLINE]: '#F2B84E',
  },
  '#BBAAA2': {
    [COLOR_KEY]: '#BBAAA2',
    [FILL]: '#BBAAA2',
    [OUTLINE]: '#77625C',
  },
  '#F3EBE8': {
    [COLOR_KEY]: '#F3EBE8',
    [FILL]: '#F3EBE8',
    [OUTLINE]: '#B49D8E',
  },
  '#FCFCFB': {
    [COLOR_KEY]: '#FCFCFB',
    [FILL]: '#FCFCFB',
    [OUTLINE]: '#C1C0C0',
  },
  '#24A5DD': {
    [COLOR_KEY]: '#24A5DD',
    [FILL]: '#24A5DD',
    [OUTLINE]: '#1D5B88',
  },
  '#FF5988': {
    [COLOR_KEY]: '#FF5988',
    [FILL]: '#FF5988',
    [OUTLINE]: '#9B002C',
  },
  '#72EE18': {
    [COLOR_KEY]: '#72EE18',
    [FILL]: '#72EE18',
    [OUTLINE]: '#378102',
  },
  '#B050F4': {
    [COLOR_KEY]: '#B050F4',
    [FILL]: '#B050F4',
    [OUTLINE]: '#460077',
  },
  '#87AEDA': {
    [COLOR_KEY]: '#87AEDA',
    [FILL]: '#87AEDA',
    [OUTLINE]: '#385474',
  },
})

export const jewelryColors = Object.freeze({
  '#FFDC2E': {
    [COLOR_KEY]: '#FFDC2E',
    [FILL]: '#FFDC2E',
  },
  '#E0E2E2': {
    [COLOR_KEY]: '#E0E2E2',
    [FILL]: '#E0E2E2',
  },
  '#F7F8F8': {
    [COLOR_KEY]: '#F7F8F8',
    [FILL]: '#F7F8F8',
  },
  '#A45C23': {
    [COLOR_KEY]: '#A45C23',
    [FILL]: '#A45C23',
  },
  '#010101': {
    [COLOR_KEY]: '#010101',
    [FILL]: '#010101',
  },
})

export const shirtColors = Object.freeze({
  '#156599': {
    [COLOR_KEY]: '#156599',
    [FILL]: '#156599',
    [SECONDARYFILL]: '#156599',
    [OUTLINE]: '#183058',
    [SECONDARYOUTLINE]: '#183058',
  },
  '#2888C6': {
    [COLOR_KEY]: '#2888C6',
    [FILL]: '#2888C6',
    [SECONDARYFILL]: '#2888C6',
    [OUTLINE]: '#0A4A73',
    [SECONDARYOUTLINE]: '#0A4A73',
  },
  '#63B1C3': {
    [COLOR_KEY]: '#63B1C3',
    [FILL]: '#63B1C3',
    [SECONDARYFILL]: '#63B1C3',
    [OUTLINE]: '#198799',
    [SECONDARYOUTLINE]: '#198799',
  },
  '#B8E2E9': {
    [COLOR_KEY]: '#B8E2E9',
    [FILL]: '#B8E2E9',
    [SECONDARYFILL]: '#B8E2E9',
    [OUTLINE]: '#63B1C3',
    [SECONDARYOUTLINE]: '#63B1C3',
  },
  '#A71E1E': {
    [COLOR_KEY]: '#A71E1E',
    [FILL]: '#A71E1E',
    [SECONDARYFILL]: '#A71E1E',
    [OUTLINE]: '#500E0E',
    [SECONDARYOUTLINE]: '#500E0E',
  },
  '#E71B1B': {
    [COLOR_KEY]: '#E71B1B',
    [FILL]: '#E71B1B',
    [SECONDARYFILL]: '#E71B1B',
    [OUTLINE]: '#970405',
    [SECONDARYOUTLINE]: '#970405',
  },
  '#F05A28': {
    [COLOR_KEY]: '#F05A28',
    [FILL]: '#F05A28',
    [SECONDARYFILL]: '#F05A28',
    [OUTLINE]: '#A42D22',
    [SECONDARYOUTLINE]: '#A42D22',
  },
  '#E58217': {
    [COLOR_KEY]: '#E58217',
    [FILL]: '#E58217',
    [SECONDARYFILL]: '#E58217',
    [OUTLINE]: '#C44405',
    [SECONDARYOUTLINE]: '#C44405',
  },
  '#FFC818': {
    [COLOR_KEY]: '#FFC818',
    [FILL]: '#FFC818',
    [SECONDARYFILL]: '#FFC818',
    [OUTLINE]: '#D08629',
    [SECONDARYOUTLINE]: '#D08629',
  },
  '#039500': {
    [COLOR_KEY]: '#039500',
    [FILL]: '#039500',
    [SECONDARYFILL]: '#039500',
    [OUTLINE]: '#075105',
    [SECONDARYOUTLINE]: '#075105',
  },
  '#B8C345': {
    [COLOR_KEY]: '#B8C345',
    [FILL]: '#B8C345',
    [SECONDARYFILL]: '#B8C345',
    [OUTLINE]: '#80853C',
    [SECONDARYOUTLINE]: '#80853C',
  },
  '#D184CE': {
    [COLOR_KEY]: '#D184CE',
    [FILL]: '#D184CE',
    [SECONDARYFILL]: '#D184CE',
    [OUTLINE]: '#AB4DB5',
    [SECONDARYOUTLINE]: '#AB4DB5',
  },
  '#E3BAD7': {
    [COLOR_KEY]: '#E3BAD7',
    [FILL]: '#E3BAD7',
    [SECONDARYFILL]: '#E3BAD7',
    [OUTLINE]: '#C375AF',
    [SECONDARYOUTLINE]: '#C375AF',
  },
  '#E8D6CC': {
    [COLOR_KEY]: '#E8D6CC',
    [FILL]: '#E8D6CC',
    [SECONDARYFILL]: '#E8D6CC',
    [OUTLINE]: '#967F75',
    [SECONDARYOUTLINE]: '#967F75',
  },
  '#A3A492': {
    [COLOR_KEY]: '#A3A492',
    [FILL]: '#A3A492',
    [SECONDARYFILL]: '#A3A492',
    [OUTLINE]: '#555C4D',
    [SECONDARYOUTLINE]: '#555C4D',
  },
  '#F6F6F6': {
    [COLOR_KEY]: '#F6F6F6',
    [FILL]: '#F6F6F6',
    [SECONDARYFILL]: '#F6F6F6',
    [OUTLINE]: '#D3D3D3',
    [SECONDARYOUTLINE]: '#D3D3D3',
  },
  '#BFBFBF': {
    [COLOR_KEY]: '#BFBFBF',
    [FILL]: '#BFBFBF',
    [SECONDARYFILL]: '#BFBFBF',
    [OUTLINE]: '#6D6C6D',
    [SECONDARYOUTLINE]: '#6D6C6D',
  },
  '#6D6C6D': {
    [COLOR_KEY]: '#6D6C6D',
    [FILL]: '#6D6C6D',
    [SECONDARYFILL]: '#6D6C6D',
    [OUTLINE]: '#30302F',
    [SECONDARYOUTLINE]: '#30302F',
  },
  '#3A3A3A': {
    [COLOR_KEY]: '#3A3A3A',
    [FILL]: '#3A3A3A',
    [SECONDARYFILL]: '#3A3A3A',
    [OUTLINE]: '#020202',
    [SECONDARYOUTLINE]: '#020202',
  },
  '#00B2FF': {
    [COLOR_KEY]: '#00B2FF',
    [FILL]: '#00B2FF',
    [SECONDARYFILL]: '#00B2FF',
    [OUTLINE]: '#076B96',
    [SECONDARYOUTLINE]: '#076B96',
  },
  '#FF5988': {
    [COLOR_KEY]: '#FF5988',
    [FILL]: '#FF5988',
    [SECONDARYFILL]: '#FF5988',
    [OUTLINE]: '#9B002C',
    [SECONDARYOUTLINE]: '#9B002C',
  },
  '#FAFF00': {
    [COLOR_KEY]: '#FAFF00',
    [FILL]: '#FAFF00',
    [SECONDARYFILL]: '#FAFF00',
    [OUTLINE]: '#AFBE02',
    [SECONDARYOUTLINE]: '#AFBE02',
  },
  '#72EE18': {
    [COLOR_KEY]: '#72EE18',
    [FILL]: '#72EE18',
    [SECONDARYFILL]: '#72EE18',
    [OUTLINE]: '#378102',
    [SECONDARYOUTLINE]: '#378102',
  },
  '#B050F4': {
    [COLOR_KEY]: '#B050F4',
    [FILL]: '#B050F4',
    [SECONDARYFILL]: '#B050F4',
    [OUTLINE]: '#460077',
    [SECONDARYOUTLINE]: '#460077',
  },
})

export const mouthColors = Object.freeze({
  '#535659': {
    [COLOR_KEY]: '#535659',
    [FILL]: '#535659',
    [OUTLINE]: '#535659',
  },
  '#AD7F6D': {
    [COLOR_KEY]: '#AD7F6D',
    [FILL]: '#AD7F6D',
    [OUTLINE]: '#AD7F6D',
  },
  '#DE6591': {
    [COLOR_KEY]: '#DE6591',
    [FILL]: '#DE6591',
    [OUTLINE]: '#DE6591',
  },
  '#C4293A': {
    [COLOR_KEY]: '#C4293A',
    [FILL]: '#C4293A',
    [OUTLINE]: '#C4293A',
  },
  '#9E2D7A': {
    [COLOR_KEY]: '#9E2D7A',
    [FILL]: '#9E2D7A',
    [OUTLINE]: '#9E2D7A',
  },
  '#AB6577': {
    [COLOR_KEY]: '#AB6577',
    [FILL]: '#AB6577',
    [OUTLINE]: '#AB6577',
  },
  '#564B5B': {
    [COLOR_KEY]: '#564B5B',
    [FILL]: '#564B5B',
    [OUTLINE]: '#564B5B',
  },
})

export const colorMap = Object.freeze({
  [PART_TYPES.FACE_SHAPE]: skinColors,
  [PART_TYPES.EYES]: eyeColors,
  [PART_TYPES.HAIR]: hairColors,
  [PART_TYPES.EYEBROWS]: hairColors,
  [PART_TYPES.FACIAL_HAIR]: hairColors,
  [PART_TYPES.MOUTH]: mouthColors,
  [PART_TYPES.JEWELRY]: jewelryColors,
  [PART_TYPES.JEWELRY_EARRINGS]: jewelryColors,
  [PART_TYPES.JEWELRY_NECKLACES]: jewelryColors,
  [PART_TYPES.SHIRT]: shirtColors,
  // figure out what to do with these
  [PART_TYPES.EYE_SHADOW]: {},
  [PART_TYPES.FACIAL_LINES_CHEEK]: {},
  [PART_TYPES.FACIAL_LINES_CHIN]: {},
  [PART_TYPES.FACIAL_LINES_EYES]: {},
  [PART_TYPES.FACIAL_LINES_FOREHEAD]: {},
  [PART_TYPES.EYE_LINER]: {},
  [PART_TYPES.HATS]: {},
  [PART_TYPES.FACIAL_LINES]: {},
  [PART_TYPES.GLASSES]: {},
  [PART_TYPES.EARS]: {},
  [PART_TYPES.NOSE]: {},
  [PART_TYPES.HAIR_BACK]: {},
})

const NECESSARY_COLORS = Object.freeze({
  [PART_TYPES.FACE_SHAPE]: [FILL, OUTLINE],
  [PART_TYPES.EARS]: [FILL, OUTLINE, GRADIENT],
  [PART_TYPES.NOSE]: [GRADIENT],
  [PART_TYPES.SHIRT]: [GRADIENT, FILL, OUTLINE, SECONDARYFILL, SECONDARYOUTLINE],
  [PART_TYPES.EYES]: [PUPIL, GRADIENT, OUTLINE],
  [PART_TYPES.HAIR]: [FILL, OUTLINE],
  [PART_TYPES.HAIR_BACK]: [FILL, OUTLINE],
  [PART_TYPES.EYEBROWS]: [FILL, GRADIENT],
  [PART_TYPES.FACIAL_HAIR]: [FILL, OUTLINE, SKIN_COLOR],
  [PART_TYPES.JEWELRY]: [FILL],
  [PART_TYPES.JEWELRY_EARRINGS]: [FILL],
  [PART_TYPES.JEWELRY_NECKLACES]: [FILL],
  [PART_TYPES.MOUTH]: [OUTLINE],
  [PART_TYPES.FACIAL_LINES_CHEEK]: [OUTLINE],
  [PART_TYPES.FACIAL_LINES_CHIN]: [OUTLINE],
  [PART_TYPES.FACIAL_LINES_EYES]: [OUTLINE],
  [PART_TYPES.FACIAL_LINES_FOREHEAD]: [OUTLINE],
})

// parts the rely on another color
const skinReliantParts = [
  PART_TYPES.EARS,
  PART_TYPES.NOSE,
  PART_TYPES.SHIRT,
  PART_TYPES.MOUTH,
  PART_TYPES.EYES,
  PART_TYPES.EYEBROWS,
  PART_TYPES.FACIAL_HAIR,
  PART_TYPES.FACIAL_LINES,
  PART_TYPES.FACIAL_LINES_CHEEK,
  PART_TYPES.FACIAL_LINES_CHIN,
  PART_TYPES.FACIAL_LINES_EYES,
  PART_TYPES.FACIAL_LINES_FOREHEAD,
]
const hairReliantParts = [PART_TYPES.HAIR_BACK]

const getPotentialColors = ({ skinKey, hairKey, partType }) => {
  const faceShapeColors = colorMap[PART_TYPES.FACE_SHAPE][skinKey]
  const frontHairColors = colorMap[PART_TYPES.HAIR][hairKey]

  if (skinReliantParts.includes(partType)) {
    return { ...faceShapeColors, skinColor: faceShapeColors?.fill, skinOutline: faceShapeColors?.outline }
  }
  if (hairReliantParts.includes(partType)) {
    return frontHairColors
  }

  return {}
}

/**
 * Mobile only sends the primary color and then maps from that, we'll do the same
 */
export const getColors = ({ partType, colorKey, secondaryColorKey, skinKey, hairKey }) => {
  if (!partType || !NECESSARY_COLORS[partType]) return {}

  const partColorsMAIN = colorMap[partType][colorKey]
  const { secondaryFill, secondaryOutline } = secondaryColorKey ? colorMap[partType][secondaryColorKey] : {}
  const reliantColors = getPotentialColors({ skinKey, hairKey, partType })
  const potentialColors = {
    ...reliantColors,
    ...partColorsMAIN,
    secondaryFill,
    secondaryOutline,
  }

  // explicitly only send colors that are applicable to the given part
  const applicableColors = Object.fromEntries(
    Object.entries(potentialColors).filter(([key]) => NECESSARY_COLORS[partType].includes(key))
  )

  return applicableColors
}
